import {
  GET_ZONES_SUCCESS,
  GET_ZONES_FAILURE,
} from '../../../../config/constants/ActionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case GET_ZONES_SUCCESS: {
      return {
        ...state,
        zones: action.payload.zones,
      }
    }

    case GET_ZONES_FAILURE: {
      return {
        ...state,
        getZonesError: action.payload.error,
      }
    }

    default:
      return state
  }
}
